import { useContext } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { usePortalNode } from '../hooks/usePortalNode';
import { PopupContext } from '../../popups/PopupContext';
import s from './PopperPortal.scss';
/** Simple wrapper to stick things into a portal */
var PopperPortal = function (_a) {
    var portalClassName = _a.portalClassName, children = _a.children;
    var isInPopup = useContext(PopupContext).isInPopup;
    var portalContainer = usePortalNode('popper', classnames(isInPopup ? s['popup-portal'] : s['portal'], portalClassName));
    return portalContainer && ReactDOM.createPortal(children, portalContainer);
};
PopperPortal.displayName = 'PopperPortal';
export default PopperPortal;
//# sourceMappingURL=PopperPortal.js.map